import type { Sort } from '@/components/table/sort';
import type { PageRequest } from '@/models/listPage';

export interface EmployeeFilters {
  /** Chaque mot cherché dans le prénom, le nom ou l'email de l'employé (côté API : SearchableFilter) */
  search?: string;
  /** Référence (DIRECTOR…) ; null : tous */
  companyRole?: string | null;
}

/** Filtres à l'arrivée sur la liste : aucun */
export const DEFAULT_EMPLOYEE_FILTERS: Required<EmployeeFilters> = { search: '', companyRole: null };

/** Colonnes triables (le rôle ne l'est pas : trois valeurs, filtrées à la place) */
export type EmployeeSortKey = 'name' | 'email' | 'createdAt';

export const DEFAULT_EMPLOYEE_SORT: Sort<EmployeeSortKey> = { key: 'name', direction: 'asc' };

/** Requête GET /members d'une page des employés de la société sélectionnée (null : aucune société) */
export function buildEmployeeListRequest(
  companyId: number | null,
  { search, companyRole }: EmployeeFilters,
  sort: Sort<EmployeeSortKey>,
  page: number,
  itemsPerPage: number,
  /** Id API du rôle (liste chargée depuis l'API) */
  companyRoleId: (reference: string) => number | null = () => null,
): PageRequest | null {
  if (!companyId) return null;
  const { direction } = sort;

  return {
    filters: {
      company: companyId,
      search: search?.trim() || null,
      companyRole: companyRole ? companyRoleId(companyRole) : null,
    },
    // « Ajouté le » trie sur l'id du rattachement, qui suit l'ordre de création
    order: {
      name: { 'user.lastName': direction, 'user.firstName': direction },
      email: { 'user.email': direction },
      createdAt: { id: direction },
    }[sort.key],
    page,
    itemsPerPage,
  };
}
